"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOrderCustomLocation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const Position_1 = require("../models/Position");
let SimpleOrderCustomLocation = class SimpleOrderCustomLocation {
    name = "";
    order;
    duration;
    position;
    countryId;
};
exports.SimpleOrderCustomLocation = SimpleOrderCustomLocation;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderCustomLocation.prototype, "name", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrderCustomLocation.prototype, "order", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrderCustomLocation.prototype, "duration", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Position_1.Position),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Position_1.Position)
], SimpleOrderCustomLocation.prototype, "position", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrderCustomLocation.prototype, "countryId", void 0);
exports.SimpleOrderCustomLocation = SimpleOrderCustomLocation = __decorate([
    (0, type_graphql_1.ObjectType)("SimpleOrderCustomLocation"),
    (0, type_graphql_1.InputType)("SimpleOrderCustomLocationInput"),
    (0, class_transformer_1.Exclude)()
], SimpleOrderCustomLocation);
//# sourceMappingURL=SimpleOrderCustomLocation.js.map